import React, { useRef, useState } from "react";
import { Upload, X } from "lucide-react";
import { fileToCompressedDataURL } from "@/lib/imageUpload";

export default function ImageField({ value, onChange, label = "Imagem", testid = "image-field", maxWidth = 1600, aspect = "aspect-[4/5]" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setErr("");
    if (file.size > 8 * 1024 * 1024) {
      setErr("Imagem demasiado grande (máx. 8 MB).");
      e.target.value = "";
      return;
    }
    setBusy(true);
    try {
      const dataUrl = await fileToCompressedDataURL(file, maxWidth, 0.85);
      onChange(dataUrl);
    } catch (er) {
      setErr(er.message || "Falha ao processar imagem.");
    } finally { setBusy(false); e.target.value = ""; }
  };

  return (
    <div className="space-y-3" data-testid={testid}>
      {label && <label className="label-sm">{label}</label>}
      {value && (
        <div className="relative inline-block">
          <img src={value} alt="" className={`${aspect} w-40 object-cover brand-border border`} />
          <button type="button" onClick={() => onChange("")} className="absolute -top-2 -right-2 bg-white rounded-full p-1 brand-border border shadow" aria-label="Remover">
            <X size={14} />
          </button>
        </div>
      )}
      <div className="flex flex-wrap gap-3 items-center">
        <input ref={ref} type="file" accept="image/*" onChange={pick} className="hidden" />
        <button type="button" onClick={() => ref.current?.click()} disabled={busy} className="btn-ghost inline-flex items-center gap-2">
          <Upload size={14} /> {busy ? "A processar..." : value ? "Substituir" : "Carregar do computador"}
        </button>
      </div>
      <input
        placeholder="https://... (URL alternativo)"
        value={value?.startsWith("data:") ? "" : (value || "")}
        onChange={(e) => onChange(e.target.value)}
        className="input-line"
      />
      {err && <p className="text-xs" style={{ color: "#9E4747" }}>{err}</p>}
    </div>
  );
}
